<template>
<div class="ImportLessonElementDiv">
   <div class="container-fluid">
      <div id="myNav" class="overlay overlay-overall-width-100Perc">
          <div class="overlay-content center-aligned-div white-porition-overlay-width-80Perc background-color-white margin-bottom-2Perc">
              <div class="row">
                <div class="col-md-12 col-lg-12">
                  <div class="close-text-font-style margin-right-1Perc margin-Top-1Perc margin-bottom-5Perc cursor-pointer " v-on:click="closeOverlay">
                    <img src= "../assets/images/close.svg" class="img-responsive close-img-width-height margin-top-3Perc float-right close-image-zindex-1" alt="close-icon">
                  </div>  
                </div>
              </div>
              <div class="row vertical-align margin-bottom-2Perc">
                <div class="row col-md-2 col-lg-2"></div>
                <div class="create-lesson-input-text-style col-md-3 col-lg-3 text-align-right padding-right-0Px">
                  Course
                </div>
                <div class="col-md-4 col-lg-4">
                  <div class="form-group">
                    <div class="col-sm-12">
                      <select class="form-control" v-model="fromCourseMasterObj">
                        <option value=-1 disabled>Select</option>
                        <option v-for="courseObj in getCourseList" v-bind:key="courseObj.CourseMasterId" v-bind:value="courseObj"> {{getCourseTitle(courseObj)}}</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="row col-md-3 col-lg-3"></div>
              </div>
              <div class="row vertical-align margin-bottom-2Perc">
                <div class="row col-md-2 col-lg-2"></div>
                <div class="create-lesson-input-text-style col-md-3 col-lg-3 text-align-right padding-right-0Px">
                  Lesson
                </div>
                <div class="col-md-4 col-lg-4">
                  <div class="form-group">
                    <div class="col-sm-12">
                      <select class="form-control" v-model="selectedModuleObj">
                        <option value=-1 disabled>Select</option>
                        <option v-for="moduleObj in getLessonList" v-bind:key="moduleObj.ModuleId" v-bind:value="moduleObj" v-if="!moduleObj.IsBonusContent && moduleObj.ModuleId !== getCurrentSelectedToLessonObj.ModuleId">{{ moduleObj.Title }}</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="row col-md-3 col-lg-3"></div>
              </div>
              <div class="row vertical-align margin-bottom-2Perc">
                <div class="row col-md-2 col-lg-2"></div>
                <div class="create-lesson-input-text-style col-md-3 col-lg-3 text-align-right padding-right-0Px">
                  Elements
                </div>
                <div class="col-md-4 col-lg-4">
                  <div class="form-group">
                    <div class="col-sm-12" v-if="getSelectedModuleElementList.length > 0">
                      <div class="row" v-for="elementObj in getSelectedModuleElementList" :currElementObj="elementObj" :key="elementObj.ElementId">
                        <div class="col-md-1 col-lg-1 text-align-left">
                          <input type="checkbox" :value="elementObj.ElementId" v-model="getSelectedElementIdList">
                        </div>
                        <div class="col-md-10 col-lg-10 text-align-left padding-right-0Px">
                          {{elementObj.Title}}
                        </div>
                        <div class="col-md-1 col-lg-1">
                        </div>  
                      </div>
                    </div>
                    <div class="col-sm-12" v-else>
                      <span class="opacity font-weight-bold">Not Found.</span> 
                    </div>
                  </div>
                </div>
                <div class="row col-md-3 col-lg-3"></div>
              </div>
              <div class="row margin-bottom-2Perc">
                <div class="col-md-5 col-lg-5">
                </div>  
                <div class="col-md-2 col-lg-2">
                  <!-- ToDo: Track this -->
                  <button class="btn btn-primary btn-block create-lesson-overlay-button-BG black-font-color" @click="importElement">Import Elements</button>
                </div>  
                <div class="col-md-5 col-lg-5">
                </div>
              </div>
              <div class="row">
              </div>         
          </div>
      </div>
      <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box> 
 </div>
 </div>
</template>

<script>
import { constants } from '@/utils/constants'
import AlertBox from '@/components/AlertOverlay'
import { moduleService } from '@/server-util/module-service'
import { courseService } from '@/server-util/course-service'
import { elementService } from '@/server-util/element-service'
import { filter } from 'lodash'
export default {
  props: ['currentLessonObj', 'isComingFrom'],
  created: function () {
    this.setDefaultValues()
    // this.getCourses()
  },
  data: function () {
    return {
      showAlertDialog: false,
      errorMsg: '',
      fromCourseMasterObj: -1,
      selectedModuleObj: -1,
      lesssonList: [],
      elementList: [],
      selectedElementIds: [],
      isImportedElements: false,
      courseTypeToExclude: constants.CourseType.M365
    }
  },
  name: 'ImportLessonElementDiv',
  methods: {
    setDefaultValues: function () {
      if (this.getCurrentlySelectedCourseObj.Type === constants.CourseType.M365) {
        this.courseTypeToExclude = constants.CourseType.Normal
      } else {
        this.courseTypeToExclude = constants.CourseType.M365
      }
    },
    resetAllObjAndValues: function () {
      this.fromCourseMasterObj = -1
      this.selectedModuleObj = -1
      this.lesssonList = []
      this.elementList = []
      this.selectedElementIds = []
      this.isImportedElements = false
    },
    getCourseTitle: function (courseObj) {
      var courseName = courseObj.CourseTitle
      var courseSubTitle = courseObj.SubTitle
      if (courseSubTitle !== 'null' && courseSubTitle !== '' && courseSubTitle !== null && courseSubTitle !== undefined) {
        courseName += ' [' + courseSubTitle + ']'
      }
      return courseName
    },
    closeOverlay: function () {
      var obj = {
        isImportedLessonElement: false,
        closeOverlay: true
      }
      this.resetAllObjAndValues()
      this.$emit('closeOverlay', obj)
    },
    getCourses: function () {
      var storeObj = this.$store
      if (storeObj.state.access_token !== undefined || storeObj.state.access_token !== '' || storeObj.state.access_token !== null) {
        // AK: Check weather Course List is already present on not
        if (storeObj.state.course_list.length === 0) {
          // this.showSpinner = true
          this.$store.state.isLoading = true
        }
        courseService.listCourses(storeObj.state.access_token)
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Store given course list
              storeObj.state.course_list = responseObj.data
              // AK: Hide Spinner if its showing to user
              if (this.$store.state.isLoading === true) {
                // this.showSpinner = false
                this.$store.state.isLoading = false
              }
            } else {
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
              // AK: Hide Spinner if its showing to user
              if (this.$store.state.isLoading === true) {
                // this.showSpinner = false
                this.$store.state.isLoading = false
              }
            }
          }, errorObj => {
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
            // AK: Hide Spinner if its showing to user
            if (this.$store.state.isLoading === true) {
              // this.showSpinner = false
              this.$store.state.isLoading = false
            }
          })
      } else {
        console.log('ACCESS TOKEN IS NOT FOUND HENCE DECLINE GET COURSE LIST OPERATION')
      }
    },
    getAssociatedLessonList () {
      if (this.fromCourseMasterObj.CourseMasterId !== undefined) {
        // this.showSpinner = true
        this.$store.state.isLoading = true
        var storeObj = this.$store
        var _this = this
        moduleService
          .listModules(
            storeObj.state.access_token,
            _this.fromCourseMasterObj.CourseMasterId
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              this.$store.state.isLoading = false
              this.lesssonList = responseObj.data
              if (this.lesssonList.length === 0) {
                this.showAlertDialog = true
                this.errorMsg = 'No Lesson(s) found in selected \'' + this.fromCourseMasterObj.CourseTitle + '\'' + ((this.isComingFrom === constants.CourseSearchBarEnum.Course) ? ' Course.' : ' Assessment.')
              }
            } else {
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
            }
          }, errorObj => {
            // _this.showSpinner = false
            _this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        this.showAlertDialog = true
        this.errorMsg = 'Please select a valid master class.'
      }
    },
    importElement: function () {
      if (this.validateRequiredFieldBeforeSubmit()) {
        var storeObj = this.$store
        // var _this = this
        if (
          storeObj.state.access_token !== undefined || storeObj.state.access_token !== null || storeObj.state.access_token !== ''
        ) {
          // AK: Start showing Spinner
          this.$store.state.isLoading = true
          const formData = new FormData()
          formData.append('FromModuleId', this.getSelectedModuleObj.ModuleId)
          formData.append('ElementIds', this.selectedElementIds)
          formData.append('ToModuleId', this.getCurrentSelectedToLessonObj.ModuleId)
          moduleService
            .importElements(
              storeObj.state.access_token,
              formData
            )
            .then(responseObj => {
              if (responseObj.status >= 200 && responseObj.status < 300) {
                var importedElementCount = responseObj.data.ElementsImported
                this.isImportedElements = true
                // AK: Hide Spinner
                this.$store.state.isLoading = false
                this.showAlertDialog = true
                this.errorMsg = 'Successfully imported ' + importedElementCount + ' element(s) from \'' + this.getSelectedModuleObj.Title + '\' to \'' + this.getCurrentSelectedToLessonObj.Title + '\' lesson.'
              } else {
                // AK: Hide Spinner
                this.$store.state.isLoading = false
                this.showAlertDialog = true
                this.errorMsg = 'Oops! Something went wrong. Please try again.'
              }
            }, errorObj => {
              // AK: Hide Spinner
              this.$store.state.isLoading = false
              this.showAlertDialog = true
              if (errorObj.response === undefined) {
                this.errorMsg = constants.No_Internet_Connection_Msg
              } else {
                this.errorMsg = errorObj.response.statusText
              }
            })
        } else {
          console.log(
            'Access Token is NULL hence declined Import Lesson Operation'
          )
        }
      }
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
      if (this.isImportedElements) {
        // AK: close and refresh element list of same module
        var obj = {
          isImportedLessonElement: true,
          closeOverlay: true
        }
        this.resetAllObjAndValues()
        this.$emit('closeOverlay', obj)
        this.isImportedElements = false
      }
    },
    validateRequiredFieldBeforeSubmit: function () {
      if (this.fromCourseMasterObj === -1) {
        this.showAlertDialog = true
        this.errorMsg = 'Please select a course.'
        return false
      } else if (this.getSelectedModuleObj === -1) {
        this.showAlertDialog = true
        this.errorMsg = 'Please select a lesson.'
        return false
      } else if (this.getSelectedElementIdList.length === 0) {
        this.showAlertDialog = true
        this.errorMsg = 'Please select atleast one element to import.'
        return false
      }
      return true
    },
    getElements: function () {
      var storeObj = this.$store
      var _this = this
      // _this.showSpinner = true
      _this.$store.state.isLoading = true
      // alert(this.LessonObj.ModuleId)
      if (
        this.getSelectedModuleObj.ModuleId !== undefined ||
        this.getSelectedModuleObj.ModuleId !== null ||
        this.getSelectedModuleObj.length > 0
      ) {
        elementService
          .listElements(storeObj.state.access_token, this.getSelectedModuleObj.ModuleId)
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              this.elementList = responseObj.data
              // AK: Hide Spinner after recieving updated Lesson list
              _this.$store.state.isLoading = false
            } else {
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
              this.$store.state.isLoading = false
            }
          }, errorObj => {
            // AK: Hide Spinner
            this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log(
          'ModuleId is NULL hence declined LOADING ELEMENT LIST OPERATION'
        )
      }
    }
  },
  components: {
    'alert-box': AlertBox
  },
  computed: {
    getCurrentSelectedToLessonObj: {
      get: function () {
        return this.currentLessonObj
      }
    },
    getCourseList: {
      get: function () {
        return filter(this.$store.state.course_list, (obj) => {
          if (this.isComingFrom === constants.CourseSearchBarEnum.Course) {
            return (obj.Type !== constants.CourseType.RecommendationAssessment)
          } else {
            return (obj.Type === constants.CourseType.RecommendationAssessment)
          }
        })
      }
    },
    getLessonList: {
      get: function () {
        return this.lesssonList
      }
    },
    getCurrentCourseMasterId: {
      get: function () {
        return this.$store.state.selectedCourseObjFromFilter.CourseMasterId
      }
    },
    getSelectedModuleObj: {
      get: function () {
        return this.selectedModuleObj
      },
      set: function (newValue) {
        this.selectedModuleObj = newValue
      }
    },
    getSelectedModuleElementList: {
      get: function () {
        return this.elementList
      }
    },
    getSelectedElementIdList: {
      get: function () {
        return this.selectedElementIds
      },
      set: function (newValue) {
        this.selectedElementIds = newValue
      }
    },
    getCurrentlySelectedCourseObj: {
      get: function () {
        return this.$store.state.selectedCourseObjFromFilter
      }
    },
    getCourseTypeToExclude: {
      get: function () {
        return this.courseTypeToExclude
      }
    }
  },
  watch: {
    fromCourseMasterObj: function (newValue, oldValue) {
      this.selectedModuleObj = -1
      this.elementList = []
      this.lesssonList = []
      this.selectedElementIds = []
      if (newValue !== -1) {
        this.getAssociatedLessonList()
      }
    },
    selectedModuleObj: function (newValue, oldValue) {
      this.elementList = []
      this.selectedElementIds = []
      if (newValue !== -1) {
        this.getElements()
      }
    }
  }
}
</script>

<style scoped>
.red{
  background-color: red;
}
.MainDiv
{
  overflow-y: hidden !important;
}
.margin-Top-0Perc{
  margin-top: 0%;
}
.margin-Top-1Perc{
  margin-top: 1%;
}
.margin-Top-2Perc
{
	margin-top: 2%;
}
.margin-Top-3Perc
{
	margin-top: 3%;
}
.margin-Top-8Perc
{
	margin-top: 8%;
}
.margin-bottom-0Perc
{
	margin-bottom: 0%;
}
.margin-bottom-5Perc
{
	margin-bottom: 5%;
}
.margin-bottom-2Perc
{
	margin-bottom: 2%;
}
.margin-left-0Perc
{
    margin-left:0%;
}
.margin-left-1Perc
{
    margin-left:2%;
}
.margin-left-2Perc
{
    margin-left:2%;
}
.margin-left-3Perc{
  margin-left:3%;
}
.margin-left-4Perc
{
    margin-left:4%;
}
.margin-left-5Perc{
  margin-left:5%;
}
.margin-left-6Perc{
  margin-left:6%
}
.margin-left-9Perc
{
    margin-left:9%;
}
.padding-Left-0px
{
  padding-left: 0px !important;
}
.padding-Left-30px
{
  padding-left: 3% !important;
}
.text-align-center
{
  text-align: center;
}
.left-border
{
  border-left: 1px solid #aaa;
}

.background-color-red
{
	background-color: red;
}
.cf-border
{
	border:1px solid black;
}
.text-align-left
{
  text-align: left;
}
.font-size-1-3vw
{
  font-size: 1.3vw;
}
.font-size-20px
{
  font-size: 20px;
}
.background-gray{
  background-color: #ddd;

}

.border-rounded{
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}

  .overflow-x-hidden{
    overflow-x: hidden !important;
  }
  .font-size-18px {
  font-size: 18px;
}
.gray-border {
  border: 1px solid #aaa;
}
.white-BG {
  background-color: #ffffff;
}
.width-70Perc {
  width: 70%;
}
.width-90Perc {
  width: 90%;
}
.margin-auto{
margin: auto;
}
.margin-bottom-0px {
  margin-bottom: 0px !important;
}
.overlay {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 3;
  top: 0;
  left: 0;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.75);
  overflow-x: hidden;
  /*transition: 0.5s;*/
}
.overlay-overall-width-0Perc {
  width: 0%;
}
.overlay-overall-width-100Perc {
  width: 100% !important;
}
.overlay-content {
  position: relative;
  top: 20%;
  width: 100%;
  text-align: center;
  margin-top: 30px;
}
.center-aligned-div {
  margin: 0 auto;
}
.white-porition-overlay-width-80Perc {
  width: 80%;
}
.background-color-white {
  background-color: #ffffff !important;
}
.close-text-font-style {
  color: #aaa;
  font-size: 30px;
}
.margin-right-1Perc {
  margin-right: 1%;
}
.margin-top-2Perc {
  margin-top: 2%;
}
.cursor-pointer {
  cursor: pointer;
}
.close-img-width-height {
  width: 2%;
  height: 2%;
}
.float-right {
  float: right;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.border-rounded {
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}
.create-lesson-input-text-style {
  color: #34495e;
  font-size: 17px;
}
.padding-right-0Px {
  padding-right: 0px !important;
}
switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 30px;
}
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}
.slider.round {
  border-radius: 34px;
}
.slider.round:before {
  border-radius: 50%;
}
.text-align-right {
  text-align: right;
}
.create-lesson-overlay-button-BG {
  background-color: #f39c12 !important;
  border: 1px solid #f39c12 !important;
}
.black-font-color
{
  color: #000 !important;
}
.border-red {
  border: 1px solid red;
}
.font-weight-bold {
  font-weight: 700;
}
.opacity {
  opacity: 0.75;
}

</style>


// WEBPACK FOOTER //
// src/components/ImportLessonElementOverlay.vue